var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.5417C14.3273 33.5417 11.2258 32.6008 8.58778 30.8381C5.94974 29.0755 3.89364 26.5701 2.67948 23.6389C1.46532 20.7076 1.14765 17.4822 1.76662 14.3704C2.38559 11.2586 3.91341 8.40028 6.15688 6.15682C8.40034 3.91335 11.2587 2.38553 14.3705 1.76656C17.4823 1.14759 20.7077 1.46526 23.6389 2.67942C26.5702 3.89358 29.0755 5.94968 30.8382 8.58771C32.6009 11.2258 33.5417 14.3272 33.5417 17.5C33.5417 21.7545 31.8516 25.8348 28.8432 28.8432C25.8348 31.8516 21.7546 33.5417 17.5 33.5417ZM17.5 4.37499C14.9042 4.37499 12.3666 5.14476 10.2082 6.58695C8.04979 8.02914 6.36753 10.079 5.37413 12.4773C4.38073 14.8755 4.12081 17.5145 4.62724 20.0605C5.13367 22.6065 6.38371 24.9452 8.21927 26.7808C10.0548 28.6163 12.3935 29.8664 14.9395 30.3728C17.4855 30.8792 20.1245 30.6193 22.5228 29.6259C24.921 28.6325 26.9709 26.9502 28.4131 24.7918C29.8553 22.6335 30.625 20.0959 30.625 17.5C30.625 14.019 29.2422 10.6806 26.7808 8.21921C24.3194 5.75779 20.981 4.37499 17.5 4.37499ZM24.7917 12.3375L22.6625 10.2812L10.2813 22.6625L12.3375 24.7917L24.7917 12.3375ZM23.3334 21.875H20.4167V24.7917H23.3334V21.875ZM14.5834 10.2083H11.6667V13.125H14.5834V10.2083Z",
    fill: "#479FCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.e5d792f2c91b10dd05ee45b39beba430.svg";
export { ForwardRef as ReactComponent };